import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Slider from "@mui/material/Slider";
import { Typography } from "@mui/material";

export const FilterProducts = ({
  onFilterChange,
  filterInputs,
}: {
  onFilterChange?: (filters: any) => void;
  filterInputs: any;
}) => {
  const [priceRange, setPriceRange] = React.useState<[number, number]>([
    0, 5000,
  ]);
  const [vegNonveg, setVegNonveg] = React.useState<string[]>([]);
  const [tags, setTags] = React.useState<string[]>([]);
  const [dynamicFilters, setDynamicFiters] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (onFilterChange) {
      onFilterChange({
        priceRange,
        dynamicFilters,
        vegNonveg,
        tags,
      });
    }
  }, [priceRange, dynamicFilters, vegNonveg, tags]);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setPriceRange(newValue as [number, number]);
  };
  const ClearFilter = () => {
    setPriceRange([0, 5000]);
    setVegNonveg([]);
    setDynamicFiters([]);
    setTags([]);
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    setState: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const { value, checked } = event.target;
    setState((prev) =>
      checked ? [...prev, value] : prev.filter((v) => v !== value)
    );
  };

  return (
    <div>
      <div className="canvas-wrapper">
        <div className="canvas-body">
          <Accordion
            // defaultExpanded
            square={false}
            sx={{ boxShadow: "none", border: "none" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="vegNonveg"
              id="vegNonveg-header"
            >
              Veg/ Non Veg
            </AccordionSummary>
            <AccordionDetails>
              <ul className="tf-filter-group current-scrollbar mb_36">
                {["Veg", "Non Veg"].map((option) => (
                  <li key={option} className="list-item">
                    <input
                      type="checkbox"
                      value={option}
                      onChange={(e) => handleCheckboxChange(e, setVegNonveg)}
                      checked={vegNonveg.includes(option)}
                    />
                    &nbsp;
                    <label>{option}</label>
                  </li>
                ))}
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion square={false} sx={{ boxShadow: "none", border: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="price"
              id="price-header"
            >
              Price
            </AccordionSummary>
            <AccordionDetails>
              <Slider
                value={priceRange}
                onChange={handleSliderChange}
                valueLabelDisplay="auto"
                min={0}
                max={2000}
                step={10}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 10,
                }}
              >
                <Typography variant="body2">Min: ₹{priceRange[0]}</Typography>
                <Typography variant="body2">Max: ₹{priceRange[1]}</Typography>
              </div>
            </AccordionDetails>
          </Accordion>

          {filterInputs?.tags?.length > 0 && (
            <Accordion
              square={false}
              sx={{ boxShadow: "none", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="tags"
                id="tags-header"
              >
                Tags
              </AccordionSummary>
              <AccordionDetails>
                <ul className="list-categories current-scrollbar mb_36">
                  {filterInputs?.tags?.map((tag: any) => (
                    <li key={tag.id} className="cate-item">
                      <input
                        type="checkbox"
                        value={tag?.id}
                        onChange={(e) => handleCheckboxChange(e, setTags)}
                        checked={tags.includes(tag.id.toString())}
                      />{" "}
                      &nbsp;
                      <label>{tag.name}</label>
                    </li>
                  ))}
                </ul>
              </AccordionDetails>
            </Accordion>
          )}
          {filterInputs?.dynamic_filters?.length > 0 && (
            <Accordion
              square={false}
              sx={{ boxShadow: "none", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="flavour"
                id="flavour-header"
              >
                Dynamic Filters
              </AccordionSummary>
              <AccordionDetails>
                <ul className="tf-filter-group filter-color current-scrollbar mb_36">
                  {filterInputs?.dynamic_filters?.map((dynamic: any) => (
                    <li key={dynamic.id} className="list-item">
                      <input
                        type="checkbox"
                        value={dynamic.id}
                        onChange={(e) =>
                          handleCheckboxChange(e, setDynamicFiters)
                        }
                        checked={dynamicFilters.includes(dynamic.id.toString())}
                      />
                      &nbsp;
                      <label>{dynamic.name}</label>
                    </li>
                  ))}
                </ul>
              </AccordionDetails>
            </Accordion>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            className="filter-footer"
          >
            <button className="btn btn-secondary" onClick={() => ClearFilter()}>
              Clear Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
